import { render, staticRenderFns } from "./PostPackageGroupCreate.vue?vue&type=template&id=9ca9417a&scoped=true"
import script from "./PostPackageGroupCreate.vue?vue&type=script&lang=js"
export * from "./PostPackageGroupCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca9417a",
  null
  
)

export default component.exports